import { Component, inject } from '@angular/core';
import { DxButtonModule } from 'devextreme-angular';
import { ThemeService } from 'src/app/shared/services';

@Component({
    selector: 'app-theme-switcher',
    template: `
        <dx-button
            class="tab tab-icon-only"
            stylingMode="text"
            [icon]="themeService.currentTheme !== 'dark' ? 'moon' : 'sun'"
            (onClick)="onButtonClick()"
        ></dx-button>
    `,
    styles: [
        `
            :host {
                display: none;
            }
            .tab {
                align-items: center;
                background: transparent;
                border: 0;
                color: #ffffff;
                display: inline-flex;
                gap: 8px;
                height: 68px;
                padding: 0 20px 0 14px;
                text-decoration: none;
                font-size: 14px;
                border-bottom: 4px solid transparent;
                border-radius: 0;

                ::ng-deep.dx-icon {
                    color: #ffffff;
                }

                &.active,
                &:hover {
                    background-color: #1f3c53;
                }
            }
            .tab-icon-only {
                justify-content: center;
                padding: 0;
                position: relative;
                width: 64px;
            }
        `,
    ],
    standalone: true,
    imports: [DxButtonModule],
})
export class ThemeSwitcherComponent {
    protected themeService = inject(ThemeService);

    onButtonClick() {
        this.themeService.switchTheme();
    }
}
